import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import React, {ReactElement} from "react";
import classes from './Services.module.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface Props {
	icon: IconDefinition,
	header: string,
	description: string
}

export const Service = (props: Props): ReactElement<Props> => {
	return (
		<div className={classes.service}>
			<FontAwesomeIcon
				className={classes.icon}
				icon={props.icon}
				size='3x'
			/>
			<div className={classes.textContainer}>
				<h4 className={classes.header}>{props.header}</h4>
			</div>
			<div className={classes.delimiter}/>
			<div className={classes.textContainer}>
				<p className={classes.description}>{props.description}</p>
			</div>
		</div>
	)
}